import { FrontendPageEnum } from "shared/model/pages";

import { MamaAnswer } from "../components/chat/ai/answer/mama-answer";
import { StripeAdminManager } from "../components/stripe/stripe-admin-manager";
import { StripeOAuthRedirectPage } from "../components/stripe/stripe-oauth-redirect-page";
import { AdminSignup } from "../routes/admin-signup";
import { Chat } from "../routes/chat";
import { AdminDashboard, UserDashboard } from "../routes/dashboard";
import { Notifications } from "../routes/notifications";
import { PagList } from "../routes/pag-list";
import { Report } from "../routes/report";
import { Subscriptions } from "../routes/subscriptions";
import { RouteWithTitle } from "../util/metadata-for-active-route";

export type MainRoute = Omit<RouteWithTitle, "path"> & {
  hideInNavbar?: boolean;
};

export const frontendPages: {
  [page in FrontendPageEnum]: MainRoute;
} = {
  [FrontendPageEnum.CHAT]: {
    title: { tx: "chat.headerTitle" },
    element: <Chat />,
  },
  [FrontendPageEnum.REPORT]: {
    title: { tx: "report.headerTitle" },
    element: <Report />,
  },
  [FrontendPageEnum.SUBSCRIPTIONS]: {
    title: { tx: "subscriptions.headerTitle" },
    element: <Subscriptions />,
  },
  [FrontendPageEnum.ADMIN_DASHBOARD]: {
    title: { tx: "membersDashboard" },
    element: <AdminDashboard />,
  },
  [FrontendPageEnum.USER_DASHBOARD]: {
    title: { tx: "dashboard" },
    element: <UserDashboard />,
  },
  [FrontendPageEnum.STRIPE]: {
    title: { tx: "stripe.stripe" },
    element: <StripeAdminManager />,
  },
  [FrontendPageEnum.STRIPE_OAUTH_REDIRECT]: {
    title: {},
    hideInNavbar: true,
    element: <StripeOAuthRedirectPage />,
  },
  [FrontendPageEnum.ADMIN_SIGNUP]: {
    title: { tx: "auth.signUp.adminTitle" },
    element: <AdminSignup />,
    hideInNavbar: true,
  },
  [FrontendPageEnum.PAG_LIST]: {
    title: { tx: "pagList.headerTitle" },
    element: <PagList />,
  },
  [FrontendPageEnum.NOTIFICATIONS]: {
    title: { tx: "notifications.title" },
    element: <Notifications />,
  },
  [FrontendPageEnum.MAMA_ANSWER]: {
    title: { tx: "userStory.title" },
    element: <MamaAnswer />,
  },
};
